import { CommonModule } from '@angular/common'
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core'
import { FlexModule } from '@angular/flex-layout'
import { MatButtonModule } from '@angular/material/button'
import { PipesModule } from '@mmx/pipes'
import { AuthorizationStatusPullData } from '@mmx/shared'
import { TranslateModule } from '@ngx-translate/core'

@Component({
  selector: 'mmx-auth-status-details',
  templateUrl: './auth-status-details.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    TranslateModule,
    MatButtonModule,
    FlexModule,
    PipesModule,
  ],
})
export class AuthStatusDetailsComponent {
  @Input()
  public statusPullData: AuthorizationStatusPullData | undefined

  @Output()
  public pullStatusClicked = new EventEmitter<void>()
}
